import React from "react";
import GoogleMapOrError from "components/GoogleMapOrError"
import { getGoogleUrl } from "utilities/googlemaps";
import { MapPinType } from "./googleMapPin";

interface Props {
  location?: server.dto.Geo
  pin: MapPinType
}

export const GoogleMapLocation = ({ location, pin }: Props) => {
  if (!location) {
    return null;
  }

  return <GoogleMapOrError
    mapId="DEMO_MAP_ID"
    coordinates={[{
      position: { lat: location.lat, lng: location.lng },
      pin,
      onLoaded(_, marker) {
        google.maps.event.addListener(marker, "click", () => {
          const url = getGoogleUrl(null, location);
          if (url) {
            window.open(url);
          }
        });
      },
    }]}
    mapOptions={{
      center: { lat: location.lat, lng: location.lng },
      fullscreenControl: false,
      streetViewControl: false,
      zoomControl: false,
      mapTypeControl: false,
      zoom: 15,
      scrollwheel: false
    }}
    height={400}
    geoCode={{
      googleMapsZoom: 15,
      hasError: false,
      lookupUtc: null,
      questionMark: 0,
      userMessage: "OK",
      outcome: "userChangedMarkerOnMap",
      location: location,
    }}
    onLoaded={map => {
      google.maps.event.addListener(map, "mouseover", () => {
        map.setOptions({
          scrollwheel: true
        });
      });

      google.maps.event.addListener(map, "mouseout", () => {
        map.setOptions({
          scrollwheel: false
        });
      });
    }}
  />
}